import store from '@/store';
import { Company } from '@/models/Company';

export const commitSetUserCompanies = (companies: Company[]) => {
  store.commit('setUserCompanies', companies);
};
